import { _ as L } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.join-c1bca812.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.string.replace-f4cc3aea.js";
import { AspectRatio as M } from "./aspectRatio.js";
import "./es.string.trim-6e13db75.js";
import { c as a } from "./index-8b07dec9.js";
import { forwardRef as O, useRef as R, useMemo as _, useImperativeHandle as k } from "react";
import C, { css as s } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as F } from "./getMetrics-953aa4f8.js";
import { MediaDisclosureButton as z } from "./mediaDisclosureButton.js";
import { jsx as n, jsxs as H } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-method-is-strict-e5a3c878.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./function-apply-4756dee6.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./species-constructor-00346775.js";
import "./string-trim-14e37ad3.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./es.parse-int-d7709701.js";
var S = ["disclosureLinks", "width", "height", "minHeight", "maxHeight", "ratio", "variant", "borderRadius", "objectFit", "objectPosition", "className", "children"], $ = /* @__PURE__ */ C.img.withConfig({
  displayName: "image__StyledImage",
  componentId: "zrl9tw-0"
})(["&.Image{", ";", ";}"], function(t) {
  var i = t.theme.components.image;
  return s(i.Image);
}, function(t) {
  var i = t.$style;
  return s(i);
}), q = /* @__PURE__ */ C.div.withConfig({
  displayName: "image__ImageContent",
  componentId: "zrl9tw-1"
})(["&.Image__content{", ";}"], function(t) {
  var i = t.theme.components.image;
  return s(i.ImageContent);
});
function A(t, i) {
  var e = t.disclosureLinks, p = t.width, c = p === void 0 ? "100%" : p, g = t.height, l = g === void 0 ? "auto" : g, u = t.minHeight, d = t.maxHeight, o = t.ratio, h = t.variant, m = h === void 0 ? "default" : h, v = t.borderRadius, I = t.objectFit, f = t.objectPosition, b = t.className, j = t.children, N = L(t, S), w = F({
    label: "Image"
  }), y = R(null), r = R(null), x = _(function() {
    return o == null ? void 0 : o.split(/[:/]/).map(function(P) {
      return P.trim();
    }).join("/");
  }, [o]);
  return k(i, function() {
    return Object.assign({}, r.current || {}, {
      get container() {
        return y.current;
      },
      get image() {
        return r.current;
      }
    });
  }, []), !e && !j ? /* @__PURE__ */ n($, Object.assign({
    ref: r,
    $style: {
      width: c,
      height: l,
      minHeight: u,
      maxHeight: d,
      objectFit: I,
      objectPosition: f,
      borderRadius: v,
      aspectRatio: x
    },
    className: a(["Image", "Image--" + m, b])
  }, N, w)) : /* @__PURE__ */ H(M, {
    ref: y,
    width: c,
    height: l,
    minHeight: u,
    maxHeight: d,
    borderRadius: v,
    variant: m,
    ratio: x,
    objectFit: I,
    objectPosition: f,
    className: "Image-wrapper",
    children: [/* @__PURE__ */ n($, Object.assign({
      ref: r,
      $style: {
        width: "100%",
        height: "100%"
      },
      className: a(["Image", "Image--" + m, b])
    }, N, w)), /* @__PURE__ */ H(q, {
      className: "Image__content",
      children: [j, e && /* @__PURE__ */ n(z, Object.assign({}, e, {
        className: a(["Image__disclosure-btn", e.className]),
        style: {
          bottom: "8px",
          right: "24px"
        }
      }))]
    })]
  });
}
var Rt = /* @__PURE__ */ O(A);
export {
  Rt as Image
};
